import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Terms() {
  useEffect(() => {
    document.title = "Terms | Get Online Crew";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main className="bg-white" data-testid="terms-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <p className="text-sm font-semibold uppercase tracking-widest text-goc-primary mb-3">
            Legal
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-goc-text">
            Terms
          </h1>
          <p className="mt-4 text-sm text-goc-muted">
            These informational terms describe how this website and our lead
            process currently work. A separate signed agreement is provided
            when work begins.
          </p>

          <div className="mt-10 space-y-8 text-goc-text leading-relaxed">
            <section>
              <h2 className="text-xl font-bold">Informational website</h2>
              <p className="mt-2 text-goc-muted">
                This website is informational and used to help small business
                owners learn about our website service and request more
                information. It is not an ordering system.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Lead form</h2>
              <p className="mt-2 text-goc-muted">
                Submitting the lead form is a request for information and does
                not create a contract or obligate either party to purchase or
                deliver services. We will contact you before any work begins.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Founding pricing</h2>
              <p className="mt-2 text-goc-muted">
                Any pricing shown (including the $299 one-time setup and the
                $39 per month website service) is a founding customer offer and
                may change. Final pricing and terms are provided in writing
                before payment.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Customer materials</h2>
              <p className="mt-2 text-goc-muted">
                You retain ownership of the materials you provide us (your
                business name, logo, photos, text, and other content). By
                sharing them, you grant us permission to use them to build,
                host, and maintain your website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">No guarantees</h2>
              <p className="mt-2 text-goc-muted">
                We build professional, mobile-friendly websites that help small
                businesses look credible online. We do not guarantee traffic,
                leads, search rankings, or specific business outcomes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Separate service agreement</h2>
              <p className="mt-2 text-goc-muted">
                When we begin work, a separate signed service agreement (or
                similar written confirmation) will describe the full scope of
                the engagement, payment terms, cancellation, and other
                specifics. Those terms will control the relationship between us
                and take precedence over anything on this website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold">Changes</h2>
              <p className="mt-2 text-goc-muted">
                These terms may change as our services grow. Updates will be
                posted on this page.
              </p>
              <p className="mt-6">
                <Link
                  to="/"
                  className="text-goc-primary font-semibold hover:text-goc-deep transition-colors"
                  data-testid="terms-back-home"
                >
                  ← Back to home
                </Link>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
